import React from 'react';
import classes from './RenderServiceList.module.css';
import Button from '../../../UI/Button';
import { TrashIcon, EditIconPencil } from '../../../../Assets/icons';
import { Row, Col } from 'react-bootstrap';
const RenderServiceList = ({ list, setter, onDeleteService, onEditService }) => {
  return (
    <>
      {list.map((ele) => (
        <Row className={classes.mb22}>
          <Col sm={5} className="pe-0">
            {/* <li className={classes.list} key={ele?.serviceId}> */}
            <p className={classes.label}>{ele?.serviceName}</p>
          </Col>
          <Col sm={6} className="pe-0">
            <p className={classes.fee}>
              <span>{ele?.serviceFees}</span>

              <span
                onClick={() => {
                  if (typeof onEditService === 'function') {
                    onEditService(ele);
                    setter(ele);
                  }
                }}>
                <EditIconPencil color="var(--primary-color)" />
              </span>
            </p>
          </Col>
          <Col sm={1} style={{ display: 'flex', }}>
            <Button
              onClick={() => {
                if (typeof setter === 'function') setter(ele);
                if (typeof onDeleteService === 'function') onDeleteService();
              }}
              className={classes.action}
              variants="iconBtn"
              leftIcon={<TrashIcon color="var(--red-color)" />}
            />
          </Col>
        </Row>
      ))}
    </>
  );
};

export default RenderServiceList;
